import React, {
  createContext,
  useState,
  useEffect,
  ReactNode,
  FC,
} from "react";
import { getUser, setUser } from "../utils/storage";

// Define types
type UsersObject = {
  [category: string]: {
    [target: string]: string[];
  };
};

interface UserContextType {
  user: UsersObject;
  updateUser: (category: string, target: string, user: string[]) => void;
}

export const UserContext = createContext<UserContextType | null>(null);

export const UserProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUsers] = useState<UsersObject>({});

  useEffect(() => {
    const savedUser = getUser();
    if (savedUser) {
      setUsers(savedUser);
    }
  }, []);

  const updateUser = (category: string, target: string, user: string[]) => {
    setUsers((prev) => {
      const updated = { ...prev };
      if (!updated[category]) {
        updated[category] = {};
      }
      updated[category][target] = user;

      setUser(updated);
      return updated;
    });
  };

  return (
    <UserContext.Provider value={{ user, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};
